import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, UsersIcon, AwardIcon } from 'lucide-react';
const stats = [{
  icon: TrendingUpIcon,
  value: '$15,000+',
  label: 'Ingreso mensual recurrente promedio',
  description: '20 contratos residenciales a $400-$800/mes = entre $8,000 y $16,000 garantizados cada mes, sin importar el clima.'
}, {
  icon: UsersIcon,
  value: '$6,000/año',
  label: 'Valor promedio por cliente recurrente',
  description: 'Un contrato de mantenimiento anual en EE.UU. vale entre $4,800 y $9,600 por propiedad. Eso es lo que pierdes cada vez que un cliente se va.'
}, {
  icon: AwardIcon,
  value: '90 días',
  label: 'Para tus primeros contratos recurrentes',
  description: 'En menos de 3 meses implementamos el sistema completo y empiezas a cerrar contratos de mantenimiento de alto valor en tu zona.'
}];
export function SocialProofSection() {
  return <section className="py-24 px-6 bg-carbon border-y border-carbon-lighter" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-185">
          <span className="text-gold font-heading font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-186">
            Credibilidad y Resultados
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-187">
            No somos una agencia genérica.
          </h2>
          <p className="text-neutral-400 font-body text-lg max-w-2xl mx-auto" data-id="element-188">
            Entendemos el negocio de landscaping. Sabemos que un "lead" no sirve
            de nada si solo busca el precio más bajo. Nuestro enfoque es 100% en
            adquirir contratos recurrentes de alto valor.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-189">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-carbon-light p-8 rounded-2xl border border-carbon-lighter text-center hover:border-gold/30 transition-colors" data-id="element-190">
                <div className="w-16 h-16 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-191">
                  <Icon className="w-8 h-8 text-gold" data-id="element-192" />
                </div>
                <h3 className="font-heading text-4xl font-extrabold text-white mb-2" data-id="element-193">
                  {stat.value}
                </h3>
                <p className="font-heading text-lg font-bold text-emerald mb-4" data-id="element-194">
                  {stat.label}
                </p>
                <p className="font-body text-neutral-400 text-sm leading-relaxed" data-id="element-195">
                  {stat.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}